import React, { createContext, useState, ReactNode, useContext } from 'react';

interface VolumeContextType {
  maxVolume: number;
  setMaxVolume: (volume: number) => void;
  scanVolume: number;
  setScanVolume: (volume: number) => void;
}

const VolumeContext = createContext<VolumeContextType | null>(null);

interface VolumeProviderProps {
  children: ReactNode;
}

export const VolumeProvider: React.FC<VolumeProviderProps> = ({ children }) => {
  const [maxVolume, setMaxVolume] = useState<number>(100);
  const [scanVolume, setScanVolume] = useState<number>(0);

  return (
    <VolumeContext.Provider value={{
      maxVolume,
      setMaxVolume,
      scanVolume,
      setScanVolume
    }}>
      {children}
    </VolumeContext.Provider>
  );
};

// Custom hook for cleaner consumption
export const useVolumeContext = () => {
  const context = useContext(VolumeContext);
  if (!context) {
    throw new Error('useVolumeContext must be used within a VolumeProvider');
  }
  return context;
};